(function() {
    'use strict';

    angular
        .module('doctorclubboApp')
        .controller('Fee_agenziaDeleteController',Fee_agenziaDeleteController);

    Fee_agenziaDeleteController.$inject = ['$uibModalInstance', 'entity', 'Fee_agenzia'];

    function Fee_agenziaDeleteController($uibModalInstance, entity, Fee_agenzia) {
        var vm = this;

        vm.fee_agenzia = entity;
        vm.clear = clear;
        vm.confirmDelete = confirmDelete;

        function clear () {
            $uibModalInstance.dismiss('cancel');
        }

        function confirmDelete (id) {
            Fee_agenzia.delete({id: id},
                function () {
                    $uibModalInstance.close(true);
                });
        }
    }
})();
